export default __webpack_public_path__ + "static/media/indexPageVideo.c1ccdf3e.mp4";